export default class ApiError extends Error {
  constructor(data) {
    super(data);
    const { code, error } = data;
    this.error = {
      status: code,
    };
    this.message = error.message;
  }

  toString() {
    return this.error.status.toString();
  }

  isValidationError() {
    return this.error.status === 422;
  }
}



// WEBPACK FOOTER //
// ./src/api/helpers/ApiError.js